/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tier_Creator_NameInputs */

const en_tier_creator_name = /** @type {(inputs: Tier_Creator_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creator`)
};

const es_tier_creator_name = /** @type {(inputs: Tier_Creator_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador`)
};

const fr_tier_creator_name = /** @type {(inputs: Tier_Creator_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur`)
};

const de_tier_creator_name = /** @type {(inputs: Tier_Creator_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creator`)
};

const ja_tier_creator_name = /** @type {(inputs: Tier_Creator_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリエイター`)
};

const zh_tier_creator_name = /** @type {(inputs: Tier_Creator_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创作者`)
};

const ar_tier_creator_name = /** @type {(inputs: Tier_Creator_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مبدع (Creator)`)
};

const id_tier_creator_name = /** @type {(inputs: Tier_Creator_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreator`)
};

const it_tier_creator_name = /** @type {(inputs: Tier_Creator_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore`)
};

const ru_tier_creator_name = /** @type {(inputs: Tier_Creator_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создатель`)
};

const pt_tier_creator_name = /** @type {(inputs: Tier_Creator_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador`)
};

const ko_tier_creator_name = /** @type {(inputs: Tier_Creator_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`크리에이터 (Creator)`)
};

/**
* | output |
* | --- |
* | "Creator" |
*
* @param {Tier_Creator_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tier_creator_name = /** @type {((inputs?: Tier_Creator_NameInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tier_Creator_NameInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tier_creator_name(inputs)
	if (locale === "es") return es_tier_creator_name(inputs)
	if (locale === "fr") return fr_tier_creator_name(inputs)
	if (locale === "de") return de_tier_creator_name(inputs)
	if (locale === "ja") return ja_tier_creator_name(inputs)
	if (locale === "zh") return zh_tier_creator_name(inputs)
	if (locale === "ar") return ar_tier_creator_name(inputs)
	if (locale === "id") return id_tier_creator_name(inputs)
	if (locale === "it") return it_tier_creator_name(inputs)
	if (locale === "ru") return ru_tier_creator_name(inputs)
	if (locale === "pt") return pt_tier_creator_name(inputs)
	return ko_tier_creator_name(inputs)
});